import React from 'react';

const RulesRegulations = () => {
  return (
    <div>
      RulesRegulations
      RulesRegulations
    </div>
  );
}

export default RulesRegulations;
